import { Component, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Helper } from 'src/app/_classes';
import { ScheduledEntry, SortEntries } from 'src/app/_interfaces';
import { AnalyticsService, AppStringsService, RouteParserService, ScheduleEntriesService } from 'src/app/_services';
import { OverlayService } from 'src/app/_services/overlay.service';

import { LoadingIndicatorComponent } from '../../_modules/loading-indicator/loading-indicator.component';
import { MatFormField, MatPrefix, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatIconButton } from '@angular/material/button';
import { ScheduledEntryComponent } from '../../_modules/scheduled-entry/scheduled-entry.component';
import { MatOption } from '@angular/material/select';
import { SearchFilterPipe } from 'src/app/_pipes/search-filter/search-filter.pipe';
import { SsrlocalstoreService } from 'src/app/_services/ssr-localstore.service';

@Component({
    selector: 'app-touranment-search',
    templateUrl: './touranment-search.component.html',
    styleUrls: ['./touranment-search.component.scss'],
    imports: [LoadingIndicatorComponent, MatFormField, MatIcon, MatPrefix, MatLabel, MatInput, FormsModule, ReactiveFormsModule, MatIconButton, MatSuffix, ScheduledEntryComponent, MatOption, SearchFilterPipe]
})
export class TouranmentSearchComponent implements OnInit {
    public loading: boolean = true
    public screen_name: string = 'GolfONE Tournament Search'
    public search: FormControl = new FormControl<string>('')

    constructor(
        private router: Router,
        public appStringAPI: AppStringsService,
        private routeParser: RouteParserService,
        public ScheduleEntriesService: ScheduleEntriesService,
        private analyticsService: AnalyticsService,
        public overlayService: OverlayService,
        private dialogRef: MatDialogRef<TouranmentSearchComponent>,
        private ssr: SsrlocalstoreService
    ) { }

    get entries(): SortEntries {
        return this.ScheduleEntriesService.entries.getValue()
    }

    async ngOnInit(): Promise<void> {
        const should_load_entries = Object.values(this.ScheduleEntriesService.entries.getValue())?.every(v => !v?.length)
        if (should_load_entries) {
            this.ScheduleEntriesService.initSearchEntryState()
        }

        const event = {
            screen_name: this.screen_name,
            parameters: {}
        }

        this.analyticsService.postEvent('page_view', event)
        this.loading = false
    }

    // update_search_entry(v: string): void {
    //     this.search.setValue(v)
    // }

    handleBackground(url: string): Record<string, string> {
        const bg_url = new Helper().handleBackgroundURL(url);
        return { 'background': `${bg_url} no-repeat center`, 'background-size': 'cover' };
    }

    handleCdkPane(live: ScheduledEntry[], past: ScheduledEntry[], past_partner_events: ScheduledEntry[], upcoming: ScheduledEntry[]): string {
        if (live.length < 1 && past.length < 1 && past_partner_events.length < 1 && upcoming.length < 1) {
            return 'no-results-panel'
        } else return 'search-auto';
    }

    handleNoResults(live: ScheduledEntry[], past: ScheduledEntry[], past_partner_events: ScheduledEntry[], upcoming: ScheduledEntry[]): string {
        if (live.length < 1 && past.length < 1 && past_partner_events.length < 1 && upcoming.length < 1) {
            return 'no-results'
        } else return 'hide-no-results';
    }

    updateTourSession(entry: ScheduledEntry): void {
        // Save the teamId to use to end the tournament session in the next site launch/new total session 
        let sessions = JSON.parse(this.ssr.getItem('sessions') as string) || {};
        if (sessions?.tournament?.type) {
            sessions.tournament.team.id = entry.team_id
            this.ssr.setItem('sessions', JSON.stringify(sessions))
        }

        const video_param = (
            entry.theme?.play_video_ads ? `playad=true` :
                entry.theme?.video_ad_id ? `playadwithid=${entry.theme.video_ad_id}` : ``
        ).toLowerCase()

        const url = `bleachr://schedule/${entry.id}?${video_param}`

        this.overlayService.closeOverlay()

        if (entry.theme?.play_video_ads || entry.theme?.video_ad_id) {
            this.routeParser.parseBleachrRoutes(url)
        } else {
            this.router.navigate(['tournament', entry.team_id, entry.id])
        }

        this.dialogRef.close();
    }

    removeSearch(): void {
        this.search.reset()
    }
}
